import { useNavigate, Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle, LanguageToggle } from "@/components/ThemeLangControls";

export function AuthShell({ title, subtitle, children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="h-16 flex items-center justify-between px-5 lg:px-8">
        <Logo className="cursor-pointer" onClick={() => navigate("/")} />
        <div className="flex items-center gap-1">
          <LanguageToggle /><ThemeToggle />
        </div>
      </header>
      <div className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
            <p className="mt-2 text-muted-foreground">{subtitle}</p>
          </div>
          <div className="rounded-2xl border bg-card p-6 sm:p-8 shadow-sm">{children}</div>
        </div>
      </div>
    </div>
  );
}
